import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLicense } from '../hooks/useLicense';
import { useItList } from '../hooks/useItList';
import { useTenantData } from '../context/TenantDataContext';
import './TrailSwitch.css';

// "Revisionsspor" is one place with three views: Beslutninger (Premium), IT-opgaver and Historik. Each view is its own route and
// shows this switch in its header; the menu has one entry, Revisionsspor. Standard tenants see a small lock on Beslutninger and
// still use the other two.
const VIEWS = [
  { key: 'decisions', label: 'Beslutninger' },
  { key: 'history', label: 'Historik' },
];
// IT-opgaver stands on its own, to the right of the other two, in the IT blue, so it is easy to see.
const IT = { key: 'it-list', label: 'IT-opgaver' };

export default function TrailSwitch({ current }) {
  const navigate = useNavigate();
  const { tenantId } = useParams();
  const license = useLicense();
  const { tenant } = useTenantData();
  const { waiting } = useItList(tenant?.tenantId);
  return (
    <div className="trail-sw-row">
      <div className="trail-sw" role="group" aria-label="Revisionsspor">
        {VIEWS.map((v) => (
          <button key={v.key} type="button" className={`trail-sw__b${current === v.key ? ' is-on' : ''}`} aria-pressed={current === v.key} onClick={() => navigate(`/tenant/${tenantId}/${v.key}`)}>
            {v.label}
            {v.key === 'decisions' && !license.features.documentation && (
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-label="Kræver Premium"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></svg>
            )}
          </button>
        ))}
      </div>
      <button type="button" className={`trail-sw__it${current === IT.key ? ' is-on' : ''}`} aria-pressed={current === IT.key} onClick={() => navigate(`/tenant/${tenantId}/${IT.key}`)}>
        {IT.label}
        {waiting.length > 0 && <em>{waiting.length}</em>}
      </button>
    </div>
  );
}
